class CaseStudiesRenderer extends HTMLElement {
  constructor() {
    super();
    this.isFirstReset = true;
    this.baseUrl = this.getAttribute('base-url') || '';
    this.templateId = this.getAttribute('template-id') || 'caseStudyTemplate';
  }

  connectedCallback() {
    this.render();
    this.setupEventListeners();
  }

  render() {
    // Keep the existing content (including the server-rendered slot)
    const existingContent = this.innerHTML;
    this.innerHTML = `
      <div class="case-studies-container flow">
        ${existingContent}
      </div>
    `;
  }

  setupEventListeners() {
    window.addEventListener('new-case-study', this.handleNewCaseStudy.bind(this));
    window.addEventListener('reset-case-studies', this.resetCaseStudies.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener('new-case-study', this.handleNewCaseStudy.bind(this));
    window.removeEventListener('reset-case-studies', this.resetCaseStudies.bind(this));
  }

  handleNewCaseStudy(event) {
    const study = event.detail;
    const template = document.getElementById(this.templateId);
    if (!template) {
      console.error(`Template with id "${this.templateId}" not found`);
      return;
    }
    const caseStudyElement = this.createCaseStudyElement(template, study);
    this.querySelector('.case-studies-container').appendChild(caseStudyElement);
  }

  resetCaseStudies() {
    const container = this.querySelector('.case-studies-container');
    if (this.isFirstReset) {
      const serverRendered = this.querySelector('[slot="server-rendered"]');
      if (serverRendered) {
        serverRendered.remove();
      }
      this.isFirstReset = false;
    }
    container.innerHTML = '';
  }

  createCaseStudyElement(template, study) {
    const element = template.content.cloneNode(true);

    const headlineParent = element.querySelector('.template-headline').parentElement;
    headlineParent.innerHTML = study.title || study.header_title || study.nav_title || '';

    const textParent = element.querySelector('.template-text').parentElement;
    textParent.innerHTML = study.teaser_text || '';

    const link = element.querySelector('[name="link"]');
    link.href = study.page_uri;

    const contentTop = element.querySelector('.template-content-top');
    if (study.logo_uri) {
      const iconImg = document.createElement('img');
      iconImg.src = `${study.logo_uri}`;
      contentTop.parentElement.replaceChild(iconImg, contentTop);
    } else {
      contentTop.remove();
    }

    if (study.files) {
      const imageElement = element.querySelector('.template-media-content');
      const imageUrl = study.files.url;
      if (imageUrl) {
        imageElement.src = `${imageUrl}`;
        imageElement.classList.remove('template-media-content');
      }
    }

    return element.firstElementChild;
  }
}

customElements.define('case-studies-renderer', CaseStudiesRenderer);
